import { RootState } from "@/redux/store";

export const configSelector = (state: RootState) => state.config.config;
export const siteInfoSelector = (state: RootState) => state.config.siteInfo;
